import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { getTimestamp, updateTimestamp } from "../../../utils/getUserInformation";

/**
 * @readonly
 * @enum {number}
 */
export const LogoutReason = {
    None: 1,
    OtherTab: 2,
    Expired: 3
};

export const useSession = () => {
    const TIMEOUT_SECONDS = 3600;
    const CHECK_INTERVAL_MS = 60_000; // 1 minute
    const { instance } = useMsal();
    const [reason, setReason] = useState(LogoutReason.None);

    useEffect(() => {
        const check = (updateActivity) => {
            const lastActivity = getTimestamp();
            const account = instance.getActiveAccount();
            if (account === null) {
                setReason(LogoutReason.OtherTab);
            }
            else if (lastActivity > 0) {
                let currentActivity = (Math.floor(new Date().getTime() * 0.001));
                const result = (lastActivity + TIMEOUT_SECONDS) < currentActivity;
                if (!result && updateActivity) {
                    updateTimestamp(currentActivity);
                }
                else if (result) {
                    console.warn("expiry ", lastActivity);
                    setReason(LogoutReason.Expired);
                }
            }
        };

        check(true); // Initial mount check: update timestamp if session is active.
        const interval = setInterval(() => check(false), CHECK_INTERVAL_MS); // Periodic check: detect expiry while the user is idle on the page.
        return () => clearInterval(interval);
    }, [instance]);

    return {
        reason: reason
    };
};